import Service from 'src/service.js';

export default class InfoModel{
    static empListData(){
        Service.getEmpList();
    }

    static getFullName(){
        return Service.getCookie('fullname');
    }
}



// WEBPACK FOOTER //
// ./src/Info/InfoModel.js